module.exports = "<header-component></header-component>\n<router-outlet></router-outlet>\n"